import { CaseInfoBannerKey, CaseLandingViewProps } from "src/pages/case-landing/case-landing-view-model";
import { PortalState } from "src/api/types/enums";

export function useCaseClosedViewProps(state: PortalState): CaseLandingViewProps {
  switch (state) {
    case PortalState.NoRedressClosed: {
      return {
        bannerKey: CaseInfoBannerKey.CaseClosed,
      };
    }
    case PortalState.OptedOut: {
      return {
        bannerKey: CaseInfoBannerKey.OptedOut,
      };
    }
    default:
      return {
        bannerKey: CaseInfoBannerKey.CaseClosed,
      };
  }
}
